<template>
  <div class="about-page">
    <div class="header">
      <h1 class="page-title">建设项目环境影响评价拟审批公示</h1>
    </div>

    <div class="table-container">
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        style="width: 100%; height: 90%"
        :header-cell-style="{
          backgroundColor: '#f5f7fa',
          color: '#606266',
          fontWeight: 'bold',
          textAlign: 'center',
          fontSize: '14px',
        }"
        :cell-style="{ textAlign: 'center', fontSize: '14px' }"
        empty-text="暂无数据"
      >
        <el-table-column prop="SUBJECT" label="项目名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="text-ellipsis">
              <div type="text">{{ scope.row.SUBJECT }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="ADDRESS" label="建设地点" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="text-ellipsis">{{ scope.row.ADDRESS }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="BUILDERUNIT"
          label="建设单位"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="text-ellipsis">{{ scope.row.BUILDERUNIT }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="HPUNIT" label="环境影响报告书（表）编制单位名称">
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.HPUNIT"
              placement="top"
              :disabled="!isTextOverflow(scope.row.HPUNIT)"
            >
              <div class="text-ellipsis">{{ scope.row.HPUNIT }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="GONGSHIBEGINDATE"
          label="公示时间"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="text-ellipsis">
              {{ formatDate(scope.row.GONGSHIBEGINDATE) }}~{{
                formatDate(scope.row.GONGSHIENDDATE)
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="GONGSHIBEGINDATE"
          label="建设项目概况"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="text-ellipsis">
              {{ scope.row.PRJPROFILE }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="attachment"
          label="主要环境影响及预防或减轻不良环境影响的对策和措施"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.ATTACH_5 != null"
              @click="download(scope.row)"
              >点击查看</el-button
            >
            <div v-if="scope.row.ATTACH_5 == null">暂无附件</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="CANYUQINGKUANG"
          label="公众参与情况"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="text-ellipsis">
              {{
                (scope.row.CANYUQINGKUANG = ""
                  ? ""
                  : "本项目已按照本市公众参与有关规定开展了公众参与工作。")
              }}
            </div>
            <!-- <el-button
              type="text"
              v-if="scope.row.ATTACH_6 != null"
              @click="downloadS(scope.row)"
              >点击查看</el-button
            >
            <div v-if="scope.row.ATTACH_6 == null">
              本项目已按照本市公众参与有关规定开展了公众参与工作。
            </div> -->
          </template>
        </el-table-column>

        <el-table-column
          prop="GONGSHIYIJIAN"
          label="备注"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- <el-button
              type="text"
              v-if="scope.row.isExpired == '未过期'"
              @click="download(scope.row)"
              >点击查看</el-button
            > -->
            <div v-if="scope.row.isExpired == '未过期'">
              {{ scope.row.GONGSHIYIJIAN }}
            </div>
            <div v-if="scope.row.isExpired == '已过期'">
              {{ scope.row.isExpired }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { login, AuditResult, FileListDownLoadWithName } from "@/api/user";
// import { post } from "@/utils/request";
import axios from "axios";

export default {
  name: "AboutPage",
  data() {
    return {
      tableData: [],
      loading: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    // this.fetchData();
    this.handleLogin();
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      // 假设日期格式为 "2026-03-27 00:00:00.000"，取空格前部分
      return dateStr.split(" ")[0];
    },
    async handleLogin() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      try {
        const res = await login({ username: "hpuser", password: "5xx$fGc" });
        // this.$message.success("登录成功");
        // localStorage.setItem("token", res.data.accessToken);
        // localStorage.setItem("refreshToken", res.data.refreshToken);
        // this.AuditResult();
        if (res.data) {
          localStorage.setItem("token", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          this.AuditResult();
        }
        if (res.httpStatusCode == 20001 || res.httpStatusCode == 20002) {
          this.postRefresh();
        }
        // 处理 token 等
      } catch (error) {
        // 错误已在拦截器中处理，这里可忽略或补充逻辑
      }
    },
    // 获取数据
    async AuditResult() {
      try {
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
        };
        const res = await AuditResult(params);
        console.log(res);
        this.tableData = res.data.records.map((item) => ({
          ...item,
          isExpired:
            new Date() > new Date(item.GONGSHIENDDATE) ? "已过期" : "未过期",
        }));
        console.log(this.tableData);
        this.pagination.total = res.data.total;
        // 处理 token 等
      } catch (error) {
        // 错误已在拦截器中处理，这里可忽略或补充逻辑
      }
    },

    async postRefresh(a, value) {
      try {
        const params = {};

        // 创建 axios 实例，设置超时时间和忽略 SSL 证书验证（如果需要）
        const instance = axios.create({
          timeout: 10000,
          // //如果接口有 SSL 证书问题，可以添加以下配置（生产环境不建议）
          // httpsAgent: new (require("https").Agent)({
          //   rejectUnauthorized: false,
          // }),
        });
        const res = await instance.post(
          "http://211.136.184.90:8090/hp/auth/refresh",
          params,
          {
            headers: {
              "refresh-token": localStorage.getItem("refreshToken"),
            },
          },
        );
        if (res.data) {
          localStorage.setItem("token", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          if (a == 1) {
            this.download(value);
          } else {
            this.AuditResult();
          }
        }
      } catch (error) {
        console.error("请求失败:", error);
        // 下载流程里刷新 token 失败时与附件缺失一致提示
        this.$message.warning(a === 1 ? "暂无附件" : "暂无数据！");
        // 请求失败时使用模拟数据
      } finally {
        this.loading = false;
      }
    },
    async download(value) {
      // console.log(value);
      const params = { WF_CASEID: value.ATTACH_5 };
      const res = await FileListDownLoadWithName(params);
      if (res.httpStatusCode == 20001) {
        this.postRefresh(1, value);
        return;
      }
      console.log(res);
      window.open(res.data[0].FILEPATH);
    },
    async downloadS(value) {
      // console.log(value);
      const params = { WF_CASEID: value.ATTACH_6 };
      const res = await FileListDownLoadWithName(params);
      window.open(res.data[0].FILEPATH);
      console.log(res);
    },
    // 判断文本是否溢出（简单实现）
    isTextOverflow(text) {
      if (!text) return false;
      // 这里可以根据实际情况调整长度阈值
      return text.length > 20;
    },

    // 使用模拟数据（备用）

    // 每页条数改变
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageNo = 1; // 重置到第一页
      // this.fetchData();
      this.AuditResult();
    },

    // 当前页改变
    handleCurrentChange(pageNo) {
      this.pagination.pageNo = pageNo;
      // this.fetchData();
      this.AuditResult();
    },
  },
};
</script>

<style scoped>
.about-page {
  height: 97vh;
  display: flex;
  flex-direction: column;
  /* background-color: #f8f9fa; */
  overflow: hidden;
}

.header {
  flex-shrink: 0;
  background: white;
  padding: 20px 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

.page-title {
  text-align: center;
  margin: 0;
  color: #303133;
  font-size: 24px;
  font-weight: 600;
}

.table-container {
  flex: 1;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 文本溢出省略号样式 */
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  font-size: 12px;
}

/* 表格样式优化 */
:deep(.el-table) {
  flex: 1;
  font-size: 14px;
  height: 100% !important;
}

:deep(.el-table__body-wrapper) {
  height: calc(100% - 44px) !important;
  overflow: auto;
}

:deep(.el-table th) {
  background-color: #f5f7fa !important;
  padding: 12px 0;
}

:deep(.el-table td) {
  padding: 12px 0;
}

:deep(.el-table .cell) {
  padding: 0 12px;
  line-height: 1.4;
  /* 确保单元格内容也应用省略号 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.el-table--border) {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

:deep(.el-table--border th) {
  border-right: 1px solid #ebeef5;
}

:deep(.el-table--border td) {
  border-right: 1px solid #ebeef5;
}

:deep(.el-table--border::after) {
  background-color: #ebeef5;
}

:deep(.el-table--border::before) {
  background-color: #ebeef5;
}

/* 按钮文本溢出处理 */
:deep(.el-table .cell .el-button) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}

/* 加载样式 */
:deep(.el-loading-mask) {
  background-color: rgba(255, 255, 255, 0.8);
}

/* 分页样式 */
:deep(.el-pagination) {
  padding: 0;
}

:deep(.el-pagination .el-select .el-input .el-input__inner) {
  padding-right: 25px;
}

/* Tooltip 样式优化 */
:deep(.el-tooltip__popper) {
  max-width: 400px;
  word-break: break-all;
  line-height: 1.5;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .table-container {
    padding: 15px;
  }

  .header {
    padding: 15px 20px;
  }

  .page-title {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .table-container {
    padding: 10px;
  }

  .header {
    padding: 12px 15px;
  }

  .page-title {
    font-size: 18px;
  }

  .pagination-container {
    justify-content: center;
  }

  :deep(.el-pagination) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  :deep(.el-tooltip__popper) {
    max-width: 300px;
  }
}
</style>
